import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Button, Textarea } from '../../_atoms';
import backImg from '../../styles/images/icons/back.png';
import edit from '../../styles/images/icons/edit.png';
import { ReactComponent as Ok } from '../../styles/images/icons/success.svg';
import { useScrollTop } from '../../helpers/useScrollTop';

export const ExtraPostcards = ({ onBack, addToBasket, numberOfCopies }) => {
  const { query = {} } = useLocation();
  useScrollTop();
  const { wishes: wishesInitial } = query;

  const { images } = useSelector(state => state.pictures.uploadedPictures);
  const [wishes, setWishes] = useState(wishesInitial || new Array(images.length).fill({ from: '', to: '', notes: '' }));
  const [wishToEditId, setWishToEditId] = useState(null);

  const onAddToBasket = () => addToBasket({ comment: '', numberOfCopies }, { wishes });

  const onOpenPopup = id => () => setWishToEditId(id);

  const onClosePopup = () => setWishToEditId(null);
  const onSubmitPopup = values => {
    setWishes(ws => ws.map((w, id) => (id === wishToEditId ? values : w)));
    setWishToEditId(null);
  };

  return (
    <div id="books_in_page" className="books-in-page postcards-extra">
      <img className="go-back" src={backImg} alt="" role="none" onClick={onBack} />
      <p className="books-in-page-title">
        Заполните поля От кого, Кому и пожелание к каждой открытке и мы их напечатаем
      </p>
      <div className="postcards-extra__images">
        {images.map(({ file_id, url, name }, idx) => (
          <div key={file_id} className="postcard-item" role="none" onClick={onOpenPopup(idx)}>
            <img src={url} alt={name} className="postcard-item__image" />
            <img src={edit} alt="edit" className="postcard-item__edit" />
            {wishes[idx].from && wishes[idx].to && wishes[idx].notes && <Ok className="postcard-item__ok" />}
          </div>
        ))}
      </div>
      <div className="divider" />
      <Button className="blue" name="currentTab" onClick={onAddToBasket}>
        Добавить в корзину
      </Button>
      <Popup
        open={wishToEditId !== null}
        initialValues={wishes[wishToEditId]}
        onSubmit={onSubmitPopup}
        onCancel={onClosePopup}
      />
    </div>
  );
};

const Popup = ({ open, onCancel, onSubmit, initialValues = {} }) => {
  const [values, setValues] = useState(initialValues);

  const onChangeValue = name => e => setValues(v => ({ ...v, [name]: e.target.value }));
  const onChangeNotes = value => setValues(v => ({ ...v, notes: value }));

  const onSubmitPopup = () => onSubmit(values);

  const onClickOutside = e => e.target.className === 'popup-overlay' && onCancel(e);

  useEffect(() => {
    setValues(initialValues);
  }, [open]);

  if (!open) return null;
  return (
    <div className="popup-overlay" role="none" onClick={onClickOutside}>
      <div className="popup">
        <div className="popup__title">Заполните поля</div>
        <p className="label">От кого</p>
        <input
          className="input-default margin-bottom-16"
          name="from"
          placeholder="Введите отправителя"
          onChange={onChangeValue('from')}
          value={values.from}
        />
        <p className="label">Кому</p>
        <input
          className="input-default margin-bottom-16"
          name="to"
          placeholder="Введите получателя"
          onChange={onChangeValue('to')}
          value={values.to}
        />
        <p className="label">Пожелания</p>
        <Textarea name="notes" placeholder="Введите пожелания" onChange={onChangeNotes} value={values.notes} />
        <div className="popup__buttons">
          <Button onClick={onCancel}>Закрыть</Button>
          <Button onClick={onSubmitPopup}>Сохранить</Button>
        </div>
      </div>
    </div>
  );
};
